<template>
  <div class="sensor-list">
    <!-- 卡片标题 -->
    <div class="tab">
      <div class="tab-left">
        <div class="tab-name">环境监测</div>
        <Dropdown class="tab-select"  @on-click="selectedChange">
          <div class="room-select-view">
            <span class="room-name">{{ roomName }}</span>
            <Icon class="room-icon" type="md-arrow-dropdown" />
          </div>
          <DropdownMenu class="dropdown-list" slot="list">
            <DropdownItem v-for="item in getRoomList" :name="item.id" :key="item.id">{{ item.nick_name }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="tab-count">
        <div class="count-text">
          <img class="count-icon" src="../assets/sensor.png">
          <div>环境监测设备总数</div>
        </div>
        <div class="count">{{ $store.getters["sensor/getSensorCount"] }}</div>
      </div>
    </div>
    <!-- 卡片内容 -->
    <div class="content">
      <!-- 加载数据样式 -->
      <Spin class="loading" v-if="loading">
        <div class="loading-container">
          <Icon class="demo-spin-icon-load" type="ios-loading" size="18" />
          <div class="loading-text">加载中...</div>
        </div>
      </Spin>
      <!-- 加载完成 -->
      <template v-else>
        <!-- 数据为空 -->
        <div class="empty" v-if="empty">
          <img class="unkown-icon" src="../assets/unkown.png" />
          <div class="empty-text">当前温室 / 园区暂无传感器</div>
        </div>
        <!-- 数据不为空 -->
        <div class="sensor" v-else v-for="item in sensorData" :key="item.id">
          <div class="circle-line-1">
            <div class="circle-line-2">
              <div class="circle-line-3">
                <div class="sensor-data">{{ item.data.number }}</div>
                <div class="sensor-unit">{{ item.unit }}</div>
              </div>
            </div>
          </div>
          <div class="sensor-name">{{ item.name + item.number }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { transitionDirection } from "../utils/tool";
export default {
  name: "sensor-list",
  data() {
    return {
      loading: true,
      empty: false,
      room: "",
      roomName: "",
      index: 1,
      groupsCount: 0,
      timer: null
    };
	},
	async created() {
		// 根据farm_id获取room_list
    await this.roomList();
    // 获取默认room_id
    this.room = this.$store.state.roomId;
    // 根据room_id获取园区名称
    const roomIndex = this.$store.state.roomList.findIndex(item => item.id === this.room);
    if (roomIndex !== -1) {
      this.roomName = this.$store.state.roomList[roomIndex].nick_name;
    } else {
      this.roomName = "无园区";
    }
    // 获取传感器类别
    await this.deviceClass();
    // 获取传感器列表
		await	this.sensorList({
			roomId: this.room
		}).then(data => {
      // console.log(data);
      let result = this.createDataGroups(data, this.$store.state.deviceClass);
      // 传感器长度为零时
      if (result.len === 0) {
        this.empty = true;
      }
      // 设置store-DeviceData
      this.$store.commit("sensor/setDeviceData", {
        deviceData: result.groups
      });
      // 设置store-DeviceCount
      this.$store.commit("sensor/setDeviceCount", {
        deviceCount: result.len
      });
      // 利用计时器切换显示组
      if (result.groups.length > 1) {
        this.groupsCount = result.groups.length;
        this.$store.commit("sensor/setShowData", {
          showData: this.$store.state.sensor.deviceData[this.index]
        });
        this.index++;
        this.timer = setInterval(() => {
          if (this.index === this.groupsCount) {
            this.index = 0;
          }
          this.$store.commit("sensor/setShowData", {
            showData: this.$store.state.sensor.deviceData[this.index]
          });
          this.index++;
        }, 3000);
      }
      this.$store.commit("sensor/setShowData", {
        showData: this.$store.state.sensor.deviceData[0]
      });
      this.loading = false;
    })
    .catch(error => {
      console.log("sensor", error);
      this.loading = false;
      this.empty = true;
    });
    // 每五分钟获取一次数据
    setInterval(() => {
      // 清除上一个timer
      clearInterval(this.timer);
      // 重新设置
      this.$store.commit("sensor/setDeviceData", {
        deviceData: []
      });
      this.$store.commit("sensor/setDeviceCount", {
        deviceCount: 0
      });
      this.$store.commit("sensor/setShowData", {
        showData: []
      });
      this.sensorList({
        roomId: this.room
      }).then(data => {
        // console.log(data);
        let result = this.createDataGroups(data, this.$store.state.deviceClass);
        if (result.len === 0) {
          this.empty = true;
        }
        // 设置store-DeviceData
        this.$store.commit("sensor/setDeviceData", {
          deviceData: result.groups
        });
        // 设置store-DeviceCount
        this.$store.commit("sensor/setDeviceCount", {
          deviceCount: result.len
        });
        // 利用计时器切换显示组
        if (result.groups.length > 1) {
          this.groupsCount = result.groups.length;
          this.timer = setInterval(() => {
            if (this.index === this.groupsCount) {
              this.index = 0;
            }
            this.$store.commit("sensor/setShowData", {
              showData: this.$store.state.sensor.deviceData[this.index]
            });
            this.index++;
          }, 3000);
        }
        this.$store.commit("sensor/setShowData", {
          showData: this.$store.state.sensor.deviceData[0]
        });
        // 关闭加载动画
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.empty = true;
        console.log("select sensor room", error);
      });
    }, 300000);
	},
	computed: {
    ...mapGetters(["getRoomList"]),
    sensorData() {
			return this.$store.state.sensor.showData;
    }
	},
	methods: {
    ...mapActions("sensor", ["sensorList"]),
    ...mapActions(["roomList", "deviceClass"]),
    selectedChange(roomId) {
      //开启加载动画
      this.loading = true;
      // 清除上一个timer
      clearInterval(this.timer);
      // 根据roomId切换园区名称
      const roomIndex = this.$store.state.roomList.findIndex(item => item.id === roomId);
      if (roomIndex !== -1) {
        this.roomName =this.$store.state.roomList[roomIndex].nick_name;
      }
      // 设置roomId
      this.room = roomId;
      // 重新设置store数据
      this.$store.commit("sensor/setDeviceData", {
        deviceData: []
      });
      this.$store.commit("sensor/setDeviceCount", {
        deviceCount: 0
      });
      this.$store.commit("sensor/setShowData", {
        showData: []
      });
      this.$store.commit("setRoomId", {
        roomId: roomId
      });
      // 请求roomId底下的数据
      this.sensorList({
        roomId: roomId
      }).then(data => {
        // console.log(data);
        let result = this.createDataGroups(data, this.$store.state.deviceClass);
        if (result.len === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        // 设置store-DeviceData
        this.$store.commit("sensor/setDeviceData", {
          deviceData: result.groups
        });
        // 设置store-DeviceCount
        this.$store.commit("sensor/setDeviceCount", {
          deviceCount: result.len
        });
        // 利用计时器切换显示组
        if (result.groups.length > 1) {
          this.groupsCount = result.groups.length;
          this.timer = setInterval(() => {
            if (this.index === this.groupsCount) {
              this.index = 0;
            }
            this.$store.commit("sensor/setShowData", {
              showData: this.$store.state.sensor.deviceData[this.index]
            });
            this.index++;
          }, 3000);
        }
        this.$store.commit("sensor/setShowData", {
          showData: this.$store.state.sensor.deviceData[0]
        });
        // 关闭加载动画
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.empty = true;
        console.log("select sensor room", error);
      });
    },
    createDataGroups(data, dataClass) {
      // 添加unit单位
      let result = data.map(item => {
        // 数据不为数字并且为 null/undedfined
        if (typeof item.data.number !== "number" && !item.data.number) {
          item.data.number = "--";
        }
        // 判断是否是整数
        if ((typeof item.data.number === "number") && !Number.isInteger(item.data.number)) {
          item.data.number = item.data.number.toFixed(2);
        }

        if ((typeof item.data.number === "number") && String(parseInt(item.data.number)).length === 4) {
          item.data.number = `${String(item.data.number).slice(0, 1)}k`;
        }

        if ((typeof item.data.number === "number") && String(parseInt(item.data.number)).length >= 5) {
          item.data.number = `${String(item.data.number).slice(0, 2)}k`;
        }

        if (item.device_class_id === 28) {
          item.data.number = item.data.number === 1 ? "有降水" : "无降水";
        }

        dataClass.forEach(device => {
          if (item.device_class_id === 27) {
            item.data.number = transitionDirection(item.data.number)
          }
          if (item.device_class_id === device.device_class_id) {
            item.unit = device.unit;
          }
        });
        return item;
      });
      // 分组数据
      let groups = [];
      let len = result.length;
      let group = [];
      let index = 0;
      for (let i = 0; i < len; ++i) {
        group.push(result[i]);
        index++;
        if (index === 8 || i === len - 1) {
          index = 0;
          groups.push(group);
          group = [];
        }
      }
      return {
        groups: groups,
        len: len
      }
    }
	}
};
</script>

<style scoped>
.sensor-list {
  position: absolute;
  top: 20px;
  left: 20px;
  height: calc((100% - 80px) / 3);
  width: 26.615vw;
  background-color: rgba(0, 40, 69, 0.8);
  border-radius: 0.5vw;
}

.tab {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-left {
  display: flex;
  align-items: center;
}

.tab-name {
  color: #ffffff;
  font-size: 1.172vw;
  padding-left: 1vw;
}

.tab-select {
  margin-left: 0.5vw;
  width: 6.4vw;
  background-color: #000c15;
  padding: 0.1vw 0.3vw;
}

.tab-select >>> .ivu-select-dropdown {
  background-color: #000c15;
  margin: 8px 0px;
  padding: 0px;
}

.dropdown-list {
  max-height: 4vw;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #000c15;
}

.ivu-dropdown-item {
  color: #ffffff;
  padding: 0.1vw 0.3vw;
  width: 6.4vw;
  font-size: 0.6vw !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ivu-dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.room-name {
  width: 6vw;
  font-size: 0.6vw;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.room-icon {
  font-size: 1vw;
  color: #00cdff;
}

.room-select-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-count {
  display: flex;
  align-items: center;
  padding-right: 1vw;
}

.count-icon {
  display: block;
  width: 1vw;
  height: 1vw;
  margin-top: 2px;
  margin-right: 0.3vw;
}

.count-text {
  color: #02bae1;
  font-size: 0.8vw;
  display: flex;
  align-items: center;
}

.count {
  color: #ffffff;
  font-size: 1vw;
  padding-left: 0.3vw;
}

.content {
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  flex-wrap: wrap;
  padding-left: 1vw;
  padding-right: 1vw;
  box-sizing: border-box;
  overflow-y: auto;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  padding-left: 0.2vw;
  font-size: 0.6vw;
}

.empty {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unkown-icon {
  width: 1vw;
  height: 1vw;
}

.empty-text {
  padding-left: 0.2vw;
  color: #808695;
  font-size: 0.6vw;
}

.sensor {
  position: relative;
  width: 25%;
  height: 6.6vw;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.circle-line-1 {
  width: 4.6vw;
  height: 4.6vw;
  border: 0.1vw solid #ffffff;
  border-radius: 2.3vw;
}

.circle-line-2 {
  width: 4.2vw;
  height: 4.2vw;
  border: 0.1vw solid #24a2bd;
  border-radius: 2.1vw;
  margin: 0.1vw auto;
}

.circle-line-3 {
  width: 3.8vw;
  height: 3.8vw;
  border: 0.1vw solid #ffffff;
  border-radius: 1.9vw;
  margin: 0.1vw auto;
}

.sensor-data {
  width: 100%;
  font-size: 0.8vw;
  color: #ffffff;
  text-align: center;
  padding-top: 0.98vw;
}

.sensor-unit {
  width: 100%;
  font-size: 0.5vw;
  color: #cccccc;
  text-align: center;
}

.sensor-name {
  width: 100%;
  font-size: 0.8vw;
  height: 2vw;
  padding-top: 0.2vw;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 4px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: gray;
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
</style>
